export const FALLBACK_COMMUNITY_SORT_ORDER = {
  defaultOrderBy: "new_posts",
  options: [
    { order_by: "new_posts", label: "Nuovi Post" },
    { order_by: "recent_activity", label: "Attività recente" },
    { order_by: "suggested", label: "Più pertinenti" },
  ],
};
